import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import I18N_RESOURCE from '@/i18n/template';
import { styled } from '@mui/material/styles';
import { Button, Grid, GridSpacingLayout, Typography } from '@/components';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import errorSvg from '@/assets/404-image.svg';
import { Box } from '@mui/material';
import useNavigate from '@/routers/useNavigate';
import { PAGES } from '@/pages/PAGE_CONSTANTS';
import { useRouteError } from '@/hooks/useRouteError';

const ErrorPageStyled = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  h1: {
    fontSize: '2rem',
  },
  img: {
    width: 'auto',
  },
}));

interface Props {
  error?: any;
  resetErrorBoundary?: () => void;
}

// These props are the default props from error boundary pattern
// currently we are not using them but the intention is to use them in the future
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ErrorPage = (props: Props) => {
  const routeError = useRouteError();
  const { error = routeError || { status: 400 } } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  console.error('routeError11:', routeError);
  let title = t('ERROR_BOUNDARY.DEFAULT_ERROR.TITLE', {
    defaultValue: I18N_RESOURCE.ERROR_BOUNDARY.DEFAULT_ERROR.TITLE,
  });
  let subtitle = t('ERROR_BOUNDARY.DEFAULT_ERROR.SUBTITLE', {
    defaultValue: I18N_RESOURCE.ERROR_BOUNDARY.DEFAULT_ERROR.SUBTITLE,
  });

  if (error) {
    if (error.status === 404) {
      title = t('ERROR_BOUNDARY.NOT_FOUND.TITLE', {
        defaultValue: I18N_RESOURCE.ERROR_BOUNDARY.NOT_FOUND.TITLE,
      });
      subtitle = t('ERROR_BOUNDARY.NOT_FOUND.SUBTITLE', {
        defaultValue: I18N_RESOURCE.ERROR_BOUNDARY.NOT_FOUND.SUBTITLE,
      });
    }
  }

  useEffect(() => {
    if (error) {
      console.error('Error caught by ErrorBoundary:', error);
      if (error.stack) {
        console.error('Error stack:', error.stack);
      }
      if (error.componentStack) {
        console.error('Component stack:', error.componentStack);
      }
    }
  }, [error]);

  const handleBackButton = () => {
    navigate({ pageName: PAGES.APP });
    if (props.resetErrorBoundary) {
      props.resetErrorBoundary();
    }
  };

  return (
    <GridSpacingLayout>
      <ErrorPageStyled>
        <Grid
          container
          flexDirection={{ xs: 'column-reverse', md: 'row' }}
          justifyContent='space-between'
          alignItems={'center'}
          spacing={2}
          paddingY={{ xs: 0, md: '4rem' }}
        >
          <Grid
            item
            xs={12}
            md={6}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            flexDirection={'column'}
            paddingBottom={{ xs: '2rem', md: 0 }}
          >
            <Box>
              <Typography variant={'h2'} marginBottom={'16px'}>
                {title}
              </Typography>
              <Typography fontSize={'1.125rem'} lineHeight={'2rem'}>
                {subtitle}
              </Typography>
              <Grid
                item
                container
                xs={12}
                gap={3}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent={{ xs: 'center', sm: 'start' }}
              >
                <Grid
                  item
                  xs={12}
                  sm={'auto'}
                  alignSelf={'center'}
                  marginTop={{ xs: '12px', sm: '40px' }}
                >
                  <Button onClick={handleBackButton} variant={'contained'}>
                    {t('ERROR_BOUNDARY.BUTTON', {
                      defaultValue: I18N_RESOURCE.ERROR_BOUNDARY.BUTTON,
                    })}
                  </Button>
                </Grid>
                {/*Contact us button will be hidden since the page that redirects to*/}
                {/*requires DX adoption since it's "Mytrimble" which not all users are on*/}
                {/*<Grid*/}
                {/*  item*/}
                {/*  display={'flex'}*/}
                {/*  xs={12}*/}
                {/*  sm={'auto'}*/}
                {/*  justifyContent={'center'}*/}
                {/*  alignItems={'center'}*/}
                {/*  width={{ xs: '100%', sm: 'auto' }}*/}
                {/*>*/}
                {/*  <Link*/}
                {/*    sx={{*/}
                {/*      fontWeight: 600,*/}
                {/*      lineHeight: '20px !important',*/}
                {/*      textUnderlineOffset: '5px',*/}
                {/*      cursor: 'pointer',*/}
                {/*      height: 'fit-content',*/}
                {/*    }}*/}
                {/*    href='https://my.trimble.com/createcase'*/}
                {/*    target='_blank'*/}
                {/*    rel='noopener noreferrer'*/}
                {/*  >*/}
                {/*    {t('ERROR_BOUNDARY.CONTACT_BUTTON', {*/}
                {/*      defaultValue: I18N_RESOURCE.ERROR_BOUNDARY.CONTACT_BUTTON,*/}
                {/*    })}*/}
                {/*  </Link>*/}
                {/*</Grid>*/}
              </Grid>
            </Box>
          </Grid>
          <Grid display={'flex'} justifyContent={'center'} item xs={12} md={6}>
            <Box
              component={'img'}
              sx={{ maxWidth: '100%', height: { xs: '300px', md: '400px' } }}
              src={errorSvg}
              alt='404'
            />
          </Grid>
        </Grid>
      </ErrorPageStyled>
    </GridSpacingLayout>
  );
};

export default ErrorPage;
